<template>
    <div v-if="prop_show">
        <v-row justify="center">
            <v-dialog
            v-model="prop_show"
            hide-overlay
            persistent
            width="320"
            >
                <v-card
                    color="success"
                    dark
                >
                    <v-card-title>
                        {{prop_heading}}
                    </v-card-title>
                    <v-card-text v-if="prop_type==='L'">
                        {{prop_message}}
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        >
                        </v-progress-linear>
                    </v-card-text>
                    <v-card-text v-else-if="prop_type==='C'">
                        {{prop_message}}
                        <v-progress-circular
                            indeterminate
                            color="white"
                            class="mb-0"
                        >
                        </v-progress-circular>
                    </v-card-text>
                    <v-card-text v-else>
                        {{prop_message}}
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        >
                        </v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default{
    name: 'ComponentLoadingIndicator',

    props:{
        prop_show:Boolean,
        prop_type:String,
        prop_heading:String,
        prop_message:String
    },

    components:{
    },

    data:function()
    {
        return{
        }
    },
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################

</script>
